// import React, { useEffect, useState } from "react";
// import { useParams, Navigate } from "react-router-dom";
// import { publicApi } from "../services/api";
// import UnitFeatures from "../components/unit/UnitFeatures";
// import UnitResults from "../components/unit/UnitResults";
// import UnitAdmissionForm from "../components/unit/UnitAdmissionForm";
// import UnitGallery from "../components/unit/UnitGallery";
// import UnitContact from "../components/unit/UnitContact";

// const UnitPage = () => {
//   const { unitId } = useParams();
//   const [unitData, setUnitData] = useState(null);
//   const [contact, setContact] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [unitResponse, dataResponse] = await Promise.all([
//           publicApi.getUnit(unitId),
//           publicApi.getAllData()
//         ]);
//         setUnitData(unitResponse.data);
//         setContact(dataResponse.data.contact);
//       } catch (error) {
//         console.error("Error fetching unit data:", error);
//         // If unit not found (404), set unitData to null to trigger redirect
//         if (error.response?.status === 404) {
//           console.warn(`Unit with unitId '${unitId}' not found. Redirecting to homepage...`);
//           setUnitData(null);
//         }
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (unitId) {
//       fetchData();
//     } else {
//       setLoading(false);
//       setUnitData(null);
//     }
//   }, [unitId]);

//   if (loading) {
//     return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>;
//   }

//   if (!unitData) {
//     return <Navigate to="/" />;
//   }

//   return (
//     <div style={{ paddingTop: '80px' }}>
//       <div style={{ textAlign: "center", padding: "2rem 0", background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)" }}>
//         <h1 style={{ fontSize: "3rem", fontWeight: "700", color: "#1e293b" }}>
//           Welcome to <span className="gradient-text">{unitData.name}</span>
//         </h1>
//       </div>

//       <UnitFeatures features={unitData.features || []} />
//       <UnitResults results={unitData.results || []} />
//       <UnitAdmissionForm unitName={unitData.name} contact={contact} />
//       <UnitGallery gallery={unitData.gallery || []} />
//       <UnitContact contact={unitData.contact} />
//     </div>
//   );
// };

// export default UnitPage;

// import React, { useEffect, useState } from "react";
// import { useParams, Navigate } from "react-router-dom";
// import { publicApi } from "../services/api";
// import UnitFeatures from "../components/unit/UnitFeatures";
// import UnitResults from "../components/unit/UnitResults";
// import UnitAdmissionForm from "../components/unit/UnitAdmissionForm";
// import UnitGallery from "../components/unit/UnitGallery";
// import UnitContact from "../components/unit/UnitContact";
// import EnglishAcademyShowcase from "../components/unit/EnglishAcademyShowcase";

// // Units that carry the full "Recommended Webpage Structure" content
// // (web page Gurukul English Medium School.docx)
// const SHOWCASE_UNITS = ["gurukul-english-academy"];

// const UnitPage = () => {
//   const { unitId } = useParams();
//   const [unitData, setUnitData] = useState(null);
//   const [contact, setContact] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [unitResponse, dataResponse] = await Promise.all([
//           publicApi.getUnit(unitId),
//           publicApi.getAllData()
//         ]);
//         setUnitData(unitResponse.data);
//         setContact(dataResponse.data.contact);
//       } catch (error) {
//         console.error("Error fetching unit data:", error);
//         // If unit not found (404), set unitData to null to trigger redirect
//         if (error.response?.status === 404) {
//           console.warn(`Unit with unitId '${unitId}' not found. Redirecting to homepage...`);
//           setUnitData(null);
//         }
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (unitId) {
//       fetchData();
//     } else {
//       setLoading(false);
//       setUnitData(null);
//     }
//   }, [unitId]);

//   if (loading) {
//     return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>;
//   }

//   if (!unitData) {
//     return <Navigate to="/" />;
//   }

//   const showShowcase = SHOWCASE_UNITS.includes(unitId);
//   const features = unitData.features || [];
//   const results = unitData.results || [];

//   return (
//     <div style={{ paddingTop: '80px' }}>
//       <div style={{ textAlign: "center", padding: "2rem 0", background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)" }}>
//         <h1 style={{ fontSize: "3rem", fontWeight: "700", color: "#1e293b" }}>
//           Welcome to <span className="gradient-text">{unitData.name}</span>
//         </h1>
//       </div>

//       {showShowcase && <EnglishAcademyShowcase />}

//       {features.length > 0 && <UnitFeatures features={features} />}
//       {results.length > 0 && <UnitResults results={results} />}
//       {/* <div id="admission-inquiry">
//         <UnitAdmissionForm unitName={unitData.name} contact={contact} />
//       </div>
//       <UnitGallery gallery={unitData.gallery || []} /> */}
//       <div id="unit-contact">
//         <UnitContact contact={unitData.contact} />
//       </div>
//     </div>
//   );
// };

// export default UnitPage;


// import React, { useEffect, useMemo, useState } from "react";
// import { useParams, Navigate } from "react-router-dom";
// import { publicApi } from "../services/api";

// import UnitFeatures from "../components/unit/UnitFeatures";
// import UnitResults from "../components/unit/UnitResults";
// import UnitAdmissionForm from "../components/unit/UnitAdmissionForm";
// import UnitGallery from "../components/unit/UnitGallery";
// import UnitContact from "../components/unit/UnitContact";

// import EnglishAcademyShowcase from "../components/unit/EnglishAcademyShowcase";
// import IITMedicalAcademyShowcase from "../components/unit/IITMedicalAcademyShowcase";

// /*
//  * Academy showcase configuration.
//  * If your backend uses different IDs, the academy name/slug is
//  * also checked below to identify the correct showcase.
//  */

// const normalizeSlug = (value = "") =>
//   String(value)
//     .toLowerCase()
//     .trim()
//     .replace(/[^a-z0-9]+/g, "-")
//     .replace(/^-+|-+$/g, "");

// const UnitPage = () => {
//   const { unitId } = useParams();

//   const [unitData, setUnitData] = useState(null);
//   const [contact, setContact] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     let active = true;

//     const fetchData = async () => {
//       setLoading(true);
//       setError("");

//       try {
//         const [unitResponse, dataResponse] = await Promise.all([
//           publicApi.getUnit(unitId),
//           publicApi.getAllData(),
//         ]);

//         if (!active) return;

//         setUnitData(unitResponse.data);
//         setContact(dataResponse.data?.contact || null);
//       } catch (err) {
//         if (!active) return;

//         console.error("Error fetching unit data:", err);

//         if (err.response?.status === 404) {
//           setUnitData(null);
//         } else {
//           setError(
//             "Unable to load academy details. Please refresh the page and try again."
//           );
//         }
//       } finally {
//         if (active) {
//           setLoading(false);
//         }
//       }
//     };

//     if (unitId) {
//       fetchData();
//     } else {
//       setUnitData(null);
//       setContact(null);
//       setLoading(false);
//     }

//     return () => {
//       active = false;
//     };
//   }, [unitId]);

//   /*
//    * Identify the academy using the URL ID and the data returned
//    * by the backend. This helps when the backend ID differs from
//    * the expected showcase ID but the academy name is available.
//    */

//   const showcaseType = useMemo(() => {
//     if (!unitData) return null;

//     const identity = [
//       unitId,
//       unitData.unitId,
//       unitData.slug,
//       unitData.name,
//     ]
//       .filter(Boolean)
//       .map(normalizeSlug)
//       .join(" ");

//     if (
//       identity.includes("iit-medical") ||
//       identity.includes("iit-medical-academy") ||
//       (identity.includes("iit") && identity.includes("medical"))
//     ) {
//       return "iit-medical";
//     }

//     if (
//       identity.includes("english-academy") ||
//       identity.includes("english-medium-school") ||
//       identity.includes("english-medium")
//     ) {
//       return "english";
//     }

//     return null;
//   }, [unitId, unitData]);

//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "50vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           padding: "2rem",
//           textAlign: "center",
//         }}
//       >
//         <p>Loading academy details...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div
//         style={{
//           minHeight: "40vh",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: "1rem",
//           padding: "2rem",
//           textAlign: "center",
//         }}
//       >
//         <p>{error}</p>

//         <button
//           type="button"
//           onClick={() => window.location.reload()}
//           style={{
//             padding: "0.75rem 1.25rem",
//             border: "none",
//             borderRadius: "8px",
//             cursor: "pointer",
//             fontWeight: 600,
//           }}
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   if (!unitData) {
//     return <Navigate to="/" replace />;
//   }

//   const features = unitData.features || [];
//   const results = unitData.results || [];
//   const gallery = unitData.gallery || [];

//   return (
//     <main
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         paddingTop: "80px",
//         overflowX: "hidden",
//       }}
//     >
//       {/* Academy heading */}
//       <section
//         style={{
//           width: "100%",
//           boxSizing: "border-box",
//           textAlign: "center",
//           padding: "clamp(1.5rem, 4vw, 2.5rem) 1rem",
//           background:
//             "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//         }}
//       >
//         <h1
//           style={{
//             fontSize: "clamp(1.6rem, 4vw, 3rem)",
//             fontWeight: 700,
//             color: "#1e293b",
//             lineHeight: 1.3,
//             margin: 0,
//             overflowWrap: "anywhere",
//           }}
//         >
//           Welcome to{" "}
//           <span className="gradient-text">{unitData.name}</span>
//         </h1>
//       </section>

//       {/* Academy-specific showcase */}
//       {showcaseType === "english" && <EnglishAcademyShowcase />}

//       {showcaseType === "iit-medical" && (
//         <IITMedicalAcademyShowcase />
//       )}

//       {/* General sections for academies without a dedicated showcase */}
//       {!showcaseType && (
//         <>
//           {features.length > 0 && (
//             <UnitFeatures features={features} />
//           )}

//           {results.length > 0 && (
//             <UnitResults results={results} />
//           )}
//         </>
//       )}

//       {/* Admission enquiry form */}
//       <section id="admission-inquiry">
//         <UnitAdmissionForm
//           unitName={unitData.name}
//           contact={contact}
//         />
//       </section>

//       {/* Academy gallery */}
//       {gallery.length > 0 && (
//         <UnitGallery gallery={gallery} />
//       )}

//       {/* Contact section */}
//       <section id="unit-contact">
//         <UnitContact contact={unitData.contact || contact} />
//       </section>
//     </main>
//   );
// };

// export default UnitPage;

import React, { useEffect, useMemo, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { publicApi } from "../services/api";

import UnitFeatures from "../components/unit/UnitFeatures";
import UnitResults from "../components/unit/UnitResults";
import UnitAdmissionForm from "../components/unit/UnitAdmissionForm";
import UnitGallery from "../components/unit/UnitGallery";
import UnitContact from "../components/unit/UnitContact";

import EnglishAcademyShowcase from "../components/unit/EnglishAcademyShowcase";
import IITMedicalAcademyShowcase from "../components/unit/IITMedicalAcademyShowcase";
import CommerceAcademyShowcase from "../components/unit/CommerceAcademyShowcase";

/*
 * Academy showcase configuration.
 * If your backend uses different IDs, the academy name/slug is
 * also checked below to identify the correct showcase.
 */

const normalizeSlug = (value = "") =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const UnitPage = () => {
  const { unitId } = useParams();

  const [unitData, setUnitData] = useState(null);
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    const fetchData = async () => {
      setLoading(true);
      setError("");

      try {
        const [unitResponse, dataResponse] = await Promise.all([
          publicApi.getUnit(unitId),
          publicApi.getAllData(),
        ]);

        if (!active) return;

        setUnitData(unitResponse.data);
        setContact(dataResponse.data?.contact || null);
      } catch (err) {
        if (!active) return;

        console.error("Error fetching unit data:", err);

        if (err.response?.status === 404) {
          setUnitData(null);
        } else {
          setError(
            "Unable to load academy details. Please refresh the page and try again."
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    if (unitId) {
      fetchData();
    } else {
      setUnitData(null);
      setContact(null);
      setLoading(false);
    }

    return () => {
      active = false;
    };
  }, [unitId]);

  /*
   * Identify the academy using the URL ID and the data returned
   * by the backend. This helps when the backend ID differs from
   * the expected showcase ID but the academy name is available.
   */

  const showcaseType = useMemo(() => {
    if (!unitData) return null;

    const identity = [
      unitId,
      unitData.unitId,
      unitData.slug,
      unitData.name,
    ]
      .filter(Boolean)
      .map(normalizeSlug)
      .join(" ");

    // IIT Medical Academy
    if (
      identity.includes("iit-medical") ||
      identity.includes("iit-medical-academy") ||
      (identity.includes("iit") && identity.includes("medical"))
    ) {
      return "iit-medical";
    }

    // Commerce Academy
    if (
      identity.includes("commerce-academy") ||
      (identity.includes("commerce") &&
        identity.includes("academy"))
    ) {
      return "commerce";
    }

    // English Academy
    if (
      identity.includes("english-academy") ||
      identity.includes("english-medium-school") ||
      identity.includes("english-medium")
    ) {
      return "english";
    }

    return null;
  }, [unitId, unitData]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "50vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <p>Loading academy details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          minHeight: "40vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <p>{error}</p>

        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "0.75rem 1.25rem",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (!unitData) {
    return <Navigate to="/" replace />;
  }

  const features = unitData.features || [];
  const results = unitData.results || [];
  const gallery = unitData.gallery || [];

  return (
    <main
      style={{
        width: "100%",
        minHeight: "100vh",
        paddingTop: "80px",
        overflowX: "hidden",
      }}
    >
      {/* Academy heading */}
      <section
        style={{
          width: "100%",
          boxSizing: "border-box",
          textAlign: "center",
          padding: "clamp(1.5rem, 4vw, 2.5rem) 1rem",
          background:
            "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(1.6rem, 4vw, 3rem)",
            fontWeight: 700,
            color: "#1e293b",
            lineHeight: 1.3,
            margin: 0,
            overflowWrap: "anywhere",
          }}
        >
          Welcome to{" "}
          <span className="gradient-text">
            {unitData.name}
          </span>
        </h1>
      </section>

      {/* Academy-specific showcase */}

      {/* English Academy */}
      {showcaseType === "english" && (
        <EnglishAcademyShowcase />
      )}

      {/* IIT Medical Academy */}
      {showcaseType === "iit-medical" && (
        <IITMedicalAcademyShowcase />
      )}

      {/* Commerce Academy */}
      {showcaseType === "commerce" && (
        <CommerceAcademyShowcase />
      )}

      {/* General sections for academies without a dedicated showcase */}
      {!showcaseType && (
        <>
          {features.length > 0 && (
            <UnitFeatures features={features} />
          )}

          {results.length > 0 && (
            <UnitResults results={results} />
          )}
        </>
      )}

      {/* Admission enquiry form */}
      <section id="admission-inquiry">
        <UnitAdmissionForm
          unitName={unitData.name}
          contact={contact}
        />
      </section>

      {/* Academy gallery */}
      {gallery.length > 0 && (
        <UnitGallery gallery={gallery} />
      )}

      {/* Contact section */}
      <section id="unit-contact">
        <UnitContact
          contact={unitData.contact || contact}
        />
      </section>
    </main>
  );
};

export default UnitPage;
